import './antMenu.less';

import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { Menu, MenuProps } from 'antd';
import { MenuInfo, SelectInfo } from '@rc-component/menu/lib/interface';
import b_ from 'b_';

type AntMenuProps = MenuProps & {};

const b = b_.with('ant-menu-wrapper');

export type AntMenuInfo<T> = MenuInfo & { sourceRow?: T };

export type AntSelectInfo = SelectInfo;

export const AntMenu = observer((props: AntMenuProps) => {
	const { className, ...antNativeProps } = props;

	const classes = classnames(b(), className);

	return <Menu onClick={() => {}} className={classes} {...antNativeProps} />;
});
